export default __webpack_public_path__ + "static/media/marker-turquoise-done.59023413.svg";